import { render, staticRenderFns } from "./type84.vue?vue&type=template&id=29d1d9d2&scoped=true"
import script from "./type84.vue?vue&type=script&lang=js"
export * from "./type84.vue?vue&type=script&lang=js"
import style0 from "./type84.vue?vue&type=style&index=0&id=29d1d9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d1d9d2",
  null
  
)

export default component.exports